import lodashSet from 'lodash.set';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';

export interface GeneralStateValues {
  doYouHaveWageIncomeieAJob: Nullable<TYesOrNo>;
  iHaveAPension: Nullable<TYesOrNo>;
  doYouReceiveAnyDividends: Nullable<TYesOrNo>;
  doYouHaveInterestIncome: Nullable<TYesOrNo>;
}

export interface GeneralState {
  values: GeneralStateValues;
}

const initialState: GeneralState = {
  values: {
    doYouHaveWageIncomeieAJob: null,
    iHaveAPension: null,
    doYouReceiveAnyDividends: null,
    doYouHaveInterestIncome: null,
  },
};

const generalSlice = createSlice({
  name: 'spouse/general',
  initialState,
  reducers: {
    update(state, action: PayloadAction<GeneralStateValues>) {
      state.values = action.payload;
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof GeneralStateValues;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire.spouseIncome.general
              .values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey } = generalSlice.actions;
export default generalSlice.reducer;

export const selectGeneral = (state: RootState) =>
  state.taxQuestionnaire.spouseIncome.general;
